module.exports = __webpack_public_path__ + "img/siteVisit.47965091.png";